import React from "react";
import styles from "../../../styles/service-section-01.module.css";
import Image from "next/image";
import BlockContent from "@sanity/block-content-to-react";
import { GilroyFontDark, GilroyFontLight } from "@lib/GilroyFont";
import Link from "next/link";
const ServiceSectionFirst = ({ data }) => {
  const {
    first_heading_h2,
    first_paragraph_h3,
    hero_image,
    alt_text,
  } = data;

  return (
    <div className={styles.main_container}>
      <div className="max-w-[100rem] m-auto py-[3rem]">
        <div className={styles.items_container}>
          <div className={styles.items_container_first_div}>
            <h1 className={`text-black  ${GilroyFontDark.className} `}>
              {" "}
              {first_heading_h2.beforeStrong?.toUpperCase()}{" "}
              {first_heading_h2?.afterStrong?.toUpperCase()}{" "}
            </h1>

            <span />
            {/* <p dangerouslySetInnerHTML={{ __html: first_paragraph_h3 }}></p> */}

            <BlockContent
              blocks={first_paragraph_h3}
              projectId="8l2jv7i6"
              dataset="production"
              serializers={{
                types: {
                  block: (props) => {
                    switch (props.node.style) {
                      case "h1":
                        return (
                          <h1
                            initial={{ x: -100, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ duration: 0.75 }}
                            className="text-4xl font-bold py-3 text-black"
                          >
                            {props.children}
                          </h1>
                        );
                      case "h2":
                        return (
                          <h2 className="text-4xl font-bold py-3 text-black">
                            {props.children}
                          </h2>
                        );
                      case "h3":
                        return (
                          <h3 className="text-2xl font-semibold py-3">
                            {props.children}
                          </h3>
                        );
                      case "h4":
                        return (
                          <h4 className="text-xl font-semibold">
                            {props.children}
                          </h4>
                        );
                      case "h5":
                        return (
                          <h5 className="text-lg font-semibold ">
                            {props.children}
                          </h5>
                        );
                      case "h6":
                        return (
                          <h6 className="text-base font-semibold ">
                            {props.children}
                          </h6>
                        );
                      case "image":
                        return (
                          <Image
                            alt='meta title here'
                            className=""
                            src={props.children}
                          />
                        );
                      default:
                        return (
                          <p
                            className={` ${styles.text_services_p1} ${GilroyFontLight.className} `}
                          >
                            {props.children}
                          </p>
                        );
                    }
                  },
                },
              }}
            />

            {/* <button>
          <Link href='/contact'>
            Contact Us
          </Link>
          </button> */}

<p className='font-bold text-[15px] text-black italic'>Highly Recommended & Trusted By</p>
    <div className='flex gap-3 sm:gap-8 justify-start '>
    <Link href={`https://www.google.com/search?gs_ssp=eJzj4tVP1zc0LEsyqEw3T8s2YLRSMahINLU0NEyxMEkyT0oxNjUxtDKoMDdKszQ1szA1NzdJMTA39-IpSU3OSE7NSS1KzCsBAHJXE0E&q=techcelerant&oq=techcele&gs_lcrp=EgZjaHJvbWUqDQgCEC4YrwEYxwEYgAQyBggAEEUYPDIGCAEQRRg8Mg0IAhAuGK8BGMcBGIAEMgYIAxBFGDkyBwgEEAAYgAQyBwgFEAAYgAQyBggGEEUYPDIGCAcQRRg80gEINDk4MmowajGoAgCwAgA&sourceid=chrome&ie=UTF-8#lrd=0xa5911d84b7bd3541:0x72f95685774d077,1,,,,`} target='_blank'>
    <Image
                        height={100}
                        width={140}
                        className="w-[110px] h-[60px] mt-2"
                        alt="facebook icon"
                        src="/rev1.png"
                      />
                      </Link>
                      <Link href={`https://www.trustpilot.com/review/techcelerant.com`} target="_blank">
                      <Image
                        height={100}
                        width={140}
                        className="w-[110px] h-[60px] mt-2"
                        alt="facebook icon"
                        src="/rev2.png"
                      />
                      </Link>

    </div>
          </div>
          <div className="relative flex flex-col items-center justify-end text-black lg:min-w-[50%] lg:max-w-[50%] ">
            {/* {isCircle ===  true &&   <svg className={styles.big_white_circle} /> } */}
            <div className="min-w-[100%]">
              <Image
                priority="true"
                height={700}
                width={700}
                alt={alt_text}
                src={hero_image}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
//
export default ServiceSectionFirst;
